import { getLogger } from "@expert/logging";
import { env } from "@/config";
import { getSharedApiClient } from "@/shared-utils";

const contextLogger = getLogger({ module: "accessTokenGenerator" });

interface TwilioTokenResponse {
    accessToken: string;
}

export async function getServiceProviderAccessToken(userFriendlyName?: string): Promise<string> {
    try {
        const { accessToken } = await getSharedApiClient()
            .post(env.accessTokenGeneratorPath, { json: { userFriendlyName } })
            .json<TwilioTokenResponse>();
        return accessToken;
    } catch (err: unknown) {
        contextLogger.error({ err });
        throw err;
    }
}
